import React, { forwardRef } from 'react';
import cn from 'classnames';
import { Popover } from '../../Popover';
import { HelperContent } from './HelperContent';
export var Helper = forwardRef(function (_a, ref) {
    var _b = _a.open, open = _b === void 0 ? false : _b, title = _a.title, body = _a.body, disableHover = _a.disableHover, children = _a.children, className = _a.className, popoverRootClassName = _a.popoverRootClassName;
    return (React.createElement(Popover, { popoverClassName: cn('lk-ui_popover-content__helper', popoverRootClassName), open: open, disableHover: disableHover, content: React.createElement(HelperContent, { ref: ref, title: title, body: body, className: className }) }, children));
});
